import moment from 'moment';
import Pagination from "../../utilities/Pagination"
import { SearchInput } from "../../components/search/Search";
import { allPaymentStatus, allServicesCategories } from "../../data/CategoriesData";
import { useTranslation } from 'react-i18next';
import ItemsToShow from "../../components/common/ItemsToShow";
import PaymentTbl from "./Components/PaymentTbl";
import { useUserPayment } from "../../context/User/UserPaymentContext";

export default function MyPayments() {
    const { t, i18n } = useTranslation();
    const { paidData, loading,
        currentPage, setCurrentPage,
        searchQuery, setSearchQuery,
        setItemsLimit, itemsLimit,
        setCurrentPaymentStatus } = useUserPayment();


    const totalPages = paidData?.data?.paginationInfo.totalPagesCount;

    //Search Query filtering 
    const filteredPaidReqests = paidData?.data?.result.filter(data =>
        data.orderType.toLowerCase().includes(searchQuery.toLowerCase()) ||
        data.amount.toString().includes(searchQuery)
    );


    if (loading) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    if (!paidData) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    moment.locale('en');

    return (
        <div className="container my-3 rounded bg-dark-beige pt-2 pb-3">
            {!(paidData?.data?.result).length ?
                (<p className="text-white text-center py-5">{t("NoPayments")}
                    <br />
                    <br />
                    <a className="btn-masar btn-dark-orange text-decoration-none p-2" href="/services">{t("goToService")}</a>
                </p>)
                : (
                    <div className="d-flex flex-wrap justify-content-center ">
                        {filteredPaidReqests !== "" &&
                            <div className="d-flex flex-wrap flex-sm-nowrap justify-content-between align-items-center col">
                                <SearchInput
                                    searchQuery={searchQuery}
                                    setSearchQuery={setSearchQuery}
                                />
                                <ItemsToShow
                                    setItemsLimit={setItemsLimit}
                                    itemsLimit={itemsLimit}
                                />
                            </div>
                        }

                        <div className="container mt-3 rounded bg-light-gray position-relative p-3 overflow-auto">
                            <div className="form-floating">
                                <select className="form-select form-select-sm w-75 mb-2"
                                    id="select-user-status"
                                    onChange={e => setCurrentPaymentStatus(e.target.value)}>
                                    <option value="">{t("All")}</option>
                                    {allPaymentStatus.map((oneStatus, index) =>
                                        <option key={index} value={oneStatus.en}>
                                            {i18n.language === "ar" ? oneStatus.ar : oneStatus.en}
                                        </option>
                                    )}
                                </select>
                                <label htmlFor="select-user-status">{t("PaymentStatus")}</label>
                            </div>

                            {filteredPaidReqests !== "" ?
                                <table className="table table-hover">
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope="col">{t("Code")}</th>
                                            <th scope="col">{t("Date")}</th>
                                            <th scope="col">{t("Details")}</th>
                                            <th scope="col">{t("Cost")}</th>
                                            <th scope="col">{t("PaymentStatus")}</th>
                                            {/* <th scope="col"></th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* {dataRequests.map((request, index) => ( */}
                                        {/* {filteredPaidReqests.map((request, index) => ( */}
                                        {(searchQuery ? filteredPaidReqests : paidData?.data?.result).map((request, index) => (
                                            <PaymentTbl
                                                key={index}
                                                orderId={request.id}
                                                orderDetails={request.orderDetails}
                                                orderType={request.orderType}
                                                orderCreated={request.createdAt}
                                                orderAmount={request.amount}
                                                orderStatus={request.status}
                                                allPaymentStatus={allPaymentStatus}
                                                allServicesCategories={allServicesCategories}
                                                moment={moment}
                                                t={t}
                                                i18n={i18n}
                                            />

                                        ))}
                                    </tbody>
                                </table>
                                :
                                <p className="text-center mt-2">لا يوجد مدفوعات حتى الآن</p>
                            }

                        </div>
                        {totalPages > 1 &&
                            <Pagination
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                totalPages={totalPages} />
                        }
                    </div>
                )}
        </div>
    )
};



